exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2_k-A9DMaU6Lk1COw65mgj{display:-webkit-box;display:-ms-flexbox;display:flex;height:20px}html[dir] ._2_k-A9DMaU6Lk1COw65mgj{padding-top:5px}html[dir=ltr] ._2_k-A9DMaU6Lk1COw65mgj{padding-left:5px}html[dir=rtl] ._2_k-A9DMaU6Lk1COw65mgj{padding-right:5px}._2_k-A9DMaU6Lk1COw65mgj ._2S2Z7UWADdA44Hs7A7wmSU{width:250px}", ""]);
// Exports
exports.locals = {
	"folderPermissionsListItem": "_2_k-A9DMaU6Lk1COw65mgj",
	"folderPermissionsNameColumn": "_2S2Z7UWADdA44Hs7A7wmSU"
};